<template>
  <div>
    <div class="sayfahead">
      <h1>Şirket Fatura</h1>
      <el-button-group v-if="Liste" class="float-right">
        <a @click="Yazdir" class="el-button YeniBtn el-button--success el-button--small"
        ><i class="feather-printer"></i> Toplu Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="5">
              <el-form-item label="Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  size="small"
                  v-model="Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="3" :offset="16">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">FATURALARI GETİR
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-table
        class="table-xs cursor-pointer yazdirma"
        style="width: 100%"
        width="100%"
        :data="Liste"
        v-if="Liste"
        show-summary
        :summary-method="TableFooter"
        :height="Height"
        @current-change="FaturaSecimi">
        <el-table-column
          prop="Tarih"
          label="Tarih"
          width="80">
        </el-table-column>
        <el-table-column
          prop="Bina"
          label="Bina Adı">
        </el-table-column>
        <el-table-column
          prop="Tutar"
          label="Tutar"
          align="right"
          width="80">
        </el-table-column>
      </el-table>
    </div>
    <FaturaYazdir @Modal="Modal=false" v-if="Modal" :Modal="Modal" :Data="FaturaData"></FaturaYazdir>
    <TopluFaturaYazdir @Modal="TopluModal=false" v-if="TopluModal" :Modal="TopluModal"
                       :TopluData="Liste"></TopluFaturaYazdir>
  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";
import FaturaYazdir from "../_Sim/Comp/FaturaYazdir";
import TopluFaturaYazdir from "../_Sim/Comp/TopluFaturaYazdir";

export default {
  components: {TopluFaturaYazdir, FaturaYazdir, Yukleniyor},
  data() {
    return {
      Tarih: [],
      lo: false,
      Liste: null,
      AltToplam: null,
      Modal: false,
      TopluModal: false,
      FaturaData: null,
      Height: null
    }
  },
  methods: {
    FaturaSecimi(e) {

      this.FaturaData = e
      this.Modal = true
    },
    Yazdir() {
      this.TopluModal = true;
    },
    Getir() {
      this.lo = true;
      this.$store.dispatch("Post", {Tarih: this.Tarih, path: '_sim/fatura'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.AltToplam = response.AltToplam;

            this.Liste = response.Data;
            this.Height = window.innerHeight - 220
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[2] = this.AltToplam;
      return sums;
    },
  },
  created() {
    var Gun = new Date();
    this.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/fatura.vue